import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'

const Transferable = {
  flags: (subscription, user) => {
    const results = []
    if (subscription.lineItem) {
      if (subscription.lineItem.isTemp) {
        results.push("is_temp")
      }
      if (subscription.lineItem.isInstructorCourse) {
        results.push("is_instructor_course")
      }
      if (subscription.lineItem.isOfficeHour) {
        results.push("is_office_hour")
      }
      if (!isWithinDaysFromNow(subscription.lineItem.processed_at, 14)) {
        results.push("processed_at_not_within_range")
      }
    }
    if (!subscription.enrollment) {
      results.push('no_enrollment')
    } else {
      // hide if not a classroom registration
      if (!subscription.enrollment.isClassroom) {
        results.push('not_classroom_registration')
      }
      if (!isWithinDaysFromNow(subscription.enrollment.start_at || subscription.enrollment.end_at || subscription.enrollment.section_end_at, 14)) {
        results.push('not_within_range')
      }
      // shopper#189 : hide if not role == student
      if (!subscription.enrollment.isRoleStudent) {
        results.push(`role_${subscription.enrollment.role}`)
      }
      if (["expired", "section_ended", "disabled"].indexOf(subscription.enrollment.status) != -1) {
        results.push(`invalid_status_${subscription.enrollment.status}`)
      }
      if (subscription.enrollment.isTemp) {
        results.push("is_temp_enroll")
      }
      // shopper#149 : only allow if user is owner of the enrollment
      if (!user.is(subscription.enrollment.owner)) {
        results.push('user_not_owner')
      }
      // shopper#205 : hide if deactivated
      if (subscription.enrollment.isDeactivated) {
        results.push('deactivated')
      }
      if (subscription.enrollment.isRetaken) {
        results.push('enrollment_retaken')
      }
    }

    return results
  }
}

export default Transferable
